import * as React from 'react';

import { calculateLargestDeposit } from '../../../providers/TransactionsProvider';
import { toCurrency } from '../../../utils/formatting';
import { type CalendarDateRange } from '../../DateRangePicker';
import Widget from '../../Widget';

import type { ColumnTable } from 'arquero';

export interface ILargestDepositRowProps {
  transactions: ColumnTable | null;
  dateRange: CalendarDateRange;
  colored?: boolean;
  showSign?: boolean;
}

const LargestDepositRow = ({ transactions, dateRange, colored = false, showSign = false }: ILargestDepositRowProps) => {
  const value = React.useMemo(() => calculateLargestDeposit(transactions, dateRange), [transactions, dateRange]);

  const valueClassName = React.useMemo(() => {
    if (colored) {
      return value >= 0 ? 'text-success-primary' : 'text-error-primary';
    }
    return '';
  }, [colored, value]);

  const formattedValue = toCurrency(value, { showSign });

  return (
    <Widget.Row variant="summary" label="Largest deposit" value={formattedValue} valueClassName={valueClassName} />
  );
};

export default LargestDepositRow;
